import { z } from 'zod'

import {
  MarketingChannel,
  MarketingCorporateListSlug,
  MarketingSegmentDefinitionKind,
  MarketingSubjectType,
} from '../constants/marketing'

export const marketingAdminSegmentDefinitionSchema = z.discriminatedUnion(
  'kind',
  [
    z.object({
      kind: z.literal(MarketingSegmentDefinitionKind.ADMIN_CORPORATE_LIST),
      corporateSlug: z.nativeEnum(MarketingCorporateListSlug),
    }),
    z.object({
      kind: z.literal(MarketingSegmentDefinitionKind.ADMIN_SUBJECT_TYPE),
      subjectType: z.nativeEnum(MarketingSubjectType),
    }),
    z.object({
      kind: z.literal(MarketingSegmentDefinitionKind.ADMIN_EMAIL_OPT_IN),
      channel: z.nativeEnum(MarketingChannel).optional(),
    }),
    z.object({
      kind: z.literal(
        MarketingSegmentDefinitionKind.ADMIN_PURCHASED_IN_LAST_DAYS
      ),
      days: z.number().int().min(1),
      eventId: z.string().min(1).optional(),
      venueIds: z.array(z.string().min(1)).optional(),
      inventoryType: z.enum(['TICKET', 'TABLE']).optional(),
    }),
  ]
)

export const marketingOrganizationSegmentDefinitionSchema =
  z.discriminatedUnion('kind', [
    z.object({
      kind: z.literal(
        MarketingSegmentDefinitionKind.ORGANIZATION_EVENT_ATTENDEES
      ),
      eventId: z.string().min(1),
      venue: z.string().min(1).optional(),
    }),
    z.object({
      kind: z.literal(
        MarketingSegmentDefinitionKind.ORGANIZATION_EVENT_WAITLIST
      ),
      eventId: z.string().min(1),
      venue: z.string().min(1).optional(),
    }),
    z.object({
      kind: z.literal(MarketingSegmentDefinitionKind.ORGANIZATION_PAST_GUESTS),
      days: z.number().int().min(1),
      venue: z.string().min(1).optional(),
    }),
    z.object({
      kind: z.literal(
        MarketingSegmentDefinitionKind.ORGANIZATION_PURCHASED_IN_LAST_DAYS
      ),
      days: z.number().int().min(1),
      eventId: z.string().min(1).optional(),
      venueIds: z.array(z.string().min(1)).optional(),
      inventoryType: z.enum(['TICKET', 'TABLE']).optional(),
    }),
    z.object({
      kind: z.literal(
        MarketingSegmentDefinitionKind.ORGANIZATION_SIMILAR_CUSTOMERS
      ),
      eventId: z.string().min(1).optional(),
      limit: z.number().int().min(1).optional(),
      venue: z.string().min(1).optional(),
    }),
    z.object({
      kind: z.literal(
        MarketingSegmentDefinitionKind.ORGANIZATION_EVENT_TICKET_BUYERS
      ),
      eventId: z.string().min(1),
      minQuantity: z.number().int().min(1).optional(),
      venue: z.string().min(1).optional(),
    }),
  ])
